module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Gb-Hc-Ic-Ja.ffe683da.png";